// extracted by mini-css-extract-plugin
export default {"loadingContainer":"common_loadingContainer__OOFDu"};